<template>
  <div class="b_box">
    <div class="container">
      <div class="top_title">
        <div class="box_nav">
          <span
            class="box_item"
            v-for="(item,index) in dataList"
            :class="{'select_active1':item.select,'boxLeft':index===0,'boxRigtht':index===3}"
            :key="index"
            @click="selectALL(index,item)"
          >{{item.key}}</span>
        </div>
        <div class="t_data">
          <div class="s_data" v-if="selectKey=='today'">
            <div class="s_left" @click="preDate">
              <img src="../../../../assets/image/arrow_left.png" />
              <span>上一天</span>
            </div>
            <span class="center" :class="{'center_active':clickNum==0}">{{aboutDay}}</span>
            <div class="s_left s_right" :class="{'nextactive':true}" @click="nextDate">
              <span :class="{'s_active':clickNum==0}">下一天</span>
              <img src="../../../../assets/image/arrow_right.png" :class="{'s_img':clickNum==0}"/>
            </div>
          </div>
          <div class="s_data" v-if="selectKey=='week'">
            <div class="s_left" @click="preWeek">
              <img src="../../../../assets/image/arrow_left.png" />
              <span>上周</span>
            </div>
            <span
              class="center"
              :class="{'center_active':clickNum==0}"
            >{{startWeekTime}} 至 {{endWeekTime}}</span>
            <div class="s_left s_right" @click="nextWeek">
              <span :class="{'s_active':clickNum==0}">下周</span>
              <img src="../../../../assets/image/arrow_right.png" :class="{'s_img':clickNum==0}"/>
            </div>
          </div>
          <div class="s_data" v-if="selectKey=='month'">
            <div class="s_left" @click="preMouth">
              <img src="../../../../assets/image/arrow_left.png" />
              <span>上月</span>
            </div>
            <span
              class="center"
              :class="{'center_active':clickNum==0}"
            >{{currentMouth.substring(0,4)}}年{{currentMouth.substring(5,7)}}月份</span>
            <div class="s_left s_right" @click="nextMouth">
              <span :class="{'s_active':clickNum==0}">下月</span>
              <img src="../../../../assets/image/arrow_right.png" :class="{'s_img':clickNum==0}"/>
            </div>
          </div>
          <div class="s_data two_data" v-if="selectKey=='all'">
            <div class="all_left" @click="AllstartTime">
              <span :class="{'all_active':isopacity}">{{startAllTime}}</span>
              <img src="../../../../assets/image/icon_la.png" />
            </div>
            <span class="all_center" :class="{'all_active':isopacity}">至</span>
            <div class="all_left" @click="AllendTime">
              <span :class="{'all_active':isopacity}">{{endAllTime}}</span>
              <img src="../../../../assets/image/icon_la.png" />
            </div>
          </div>
          <div class="pro_item">
            <div class="item_left">
              <div class="left">
                <p class="status">{{cityName}}</p>
                <div class="num">
                  <span>{{totalPrice.allTotal}}</span>
                  <span>件</span>
                </div>
              </div>
              <div class="center"></div>
              <div class="left">
                <p class="status">平均办结时长</p>
                <div class="num">
                  <span>{{hour|filt1()}}</span>
                  <span>小时</span>
                  <span>{{minutes|filt2()}}</span>
                  <span>分钟</span>
                </div>
              </div>
            </div>
            <div class="line"></div>
          </div>
          <div class="status_num">
            <div class="status_item" v-if="baseList">
              <div class="item_num" @click="changeStatus('processing',0)">
                <p
                  class="pro_status"
                  :class="{'pro_actve':refundType=='processing'}"
                >{{baseList[0].name}}</p>
                <div class="pro_num">
                  <span :class="{'pro_actve':refundType=='processing'}">{{baseList[0].value}}</span>
                  <span :class="{'pro_actve':refundType=='processing'}">件</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="item_num" @click="changeStatus('refundSuccess',1)">
                <p
                  class="pro_status"
                  :class="{'pro_actve':refundType=='refundSuccess'}"
                >{{baseList[1].name}}</p>
                <div class="pro_num">
                  <span :class="{'pro_actve':refundType=='refundSuccess'}">{{baseList[1].value}}</span>
                  <span :class="{'pro_actve':refundType=='refundSuccess'}">件</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="item_num" @click="changeStatus('waitAccept',2)">
                <p
                  class="pro_status"
                  :class="{'pro_actve':refundType=='waitAccept'}"
                >{{baseList[2].name}}</p>
                <div class="pro_num">
                  <span :class="{'pro_actve':refundType=='waitAccept'}">{{baseList[2].value}}</span>
                  <span :class="{'pro_actve':refundType=='waitAccept'}">件</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="item_num" @click="changeStatus('userRevoke',3)">
                <p
                  class="pro_status"
                  :class="{'pro_actve':refundType=='userRevoke'}"
                >{{baseList[3].name}}</p>
                <div class="pro_num">
                  <span :class="{'pro_actve':refundType=='userRevoke'}">{{baseList[3].value}}</span>
                  <span :class="{'pro_actve':refundType=='userRevoke'}">件</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="item_num" @click="changeStatus('refuseAccept',4)">
                <p
                  class="pro_status"
                  :class="{'pro_actve':refundType=='refuseAccept'}"
                >{{baseList[4].name}}</p>
                <div class="pro_num">
                  <span :class="{'pro_actve':refundType=='refuseAccept'}">{{baseList[4].value}}</span>
                  <span :class="{'pro_actve':refundType=='refuseAccept'}">件</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="all_list">
        <div class="all_list_top">
          <div
            class="all_item"
            :class="{'line_bottom':index!=proList.length-1}"
            v-for="(item,index) in proList"
            :key="index"
            @click="goLeaderDetail(item)"
          >
            <span class="tip_one" >{{item.city}}</span>
            <div class="right">
              <span class="price" v-if='processing'>{{item.notComplete}}件</span>
              <span class="price" v-if='refundSuccess'>{{item.normalComplete}}件</span>
              <span class="price" v-if='waitAccept'>{{item.timeoutComplete}}件</span>
              <span class="price" v-if='userRevoke'>{{item.notaccept}}件</span>
              <span class="price" v-if='refuseAccept'>{{item.revocation}}件</span>
              <img src="../../../../assets/image/icon_right.png" class="arrow_right" />
            </div>
          </div>
          <div class="box1" v-if="isNolist">
            <img src="../../../../assets/empty/ic_wuxingxi.png" />
            <p class="tip1">暂无数据</p>
          </div>
        </div>
      </div>
    </div>
    <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
  </div>
</template>
<script>
    import moment from 'moment';
    import timePick from '../../../../components/base/timePick';
    import util from '../../../../utils/common';
    import API from './../../../../service/modules/complaintApis'
    export default {
        components: {
            timePick
        },
        data () {
            return {
                isNolist: false,
                dataList: [
                    { key: '日', select: true, value: 'today' },
                    { key: '周', select: false, value: 'week' },
                    { key: '月', select: false, value: 'month' },
                    { key: '全部', select: false, value: 'all' }
                ],
                baseList: '',
                currentTime: new Date().getTime(),
                currentMouth: moment(new Date().getTime()).format('YYYY-MM'),
                selectKey: this.$route.query.name,
                cityCode: this.$router.currentRoute.query.citycode,
                refundType: 'processing',
                aboutDay: moment(new Date().getTime()).format('YYYY-MM-DD'),
                startWeekTime: '',
                endWeekTime: '',
                startAllTime: '请选择开始时间',
                endAllTime: '请选择结束时间',
                changeTime: '',
                startTime: this.$store.state.refund.startTime,
                endTime: this.$store.state.refund.endTime,
                proList: [],
                total: '0',
                totalPrice: '0',
                cityName: this.$route.query.city,
                clickNum: 0,
                isopacity: true,
                totalCityPrice: 0,
                currentTotalPrice: 0,
                type: '',
                processing: true, // 处理中
                refundSuccess: false, // 正常办结
                waitAccept: false, // 超时办结
                userRevoke: false, // 不予受理
                refuseAccept: false, // 用户撤销
                hour: 0,
                minutes: 0,
                dafaultType: '',
                list: [],
                areaId: this.$route.query.areaId
            };
        },
        created () {
            this._initDate();
            this.changeStatus(this.refundType, 0);
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            _initDate () {
                // 初始化日期格式
                if (this.selectKey === 'week') {
                    let nowTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    var data = util.getWeekStartEnd(moment, nowTime);
                    this.startWeekTime = data.start;
                    this.endWeekTime = data.end;
                    this.startTime = data.start + ' ' + '00:00:00';
                    this.endTime = data.end + ' ' + '23:59:59';
                } else if (this.selectKey === 'today') {
                    let nowDate = new Date();
                    let year = nowDate.getFullYear();
                    let month = nowDate.getMonth() + 1;
                    let day = nowDate.getDate();
                    if (month < 10) {
                        month = '0' + month;
                    }
                    if (day < 10) {
                        day = '0' + day;
                    }
                    let beginDate = year + '-' + month + '-' + day + ' ' + '00:00:00';
                    let endDate = year + '-' + month + '-' + day + ' ' + '23:59:59';
                    this.startTime = beginDate;
                    this.endTime = endDate;
                } else if (this.selectKey === 'month') {
                    this.currentMouth = moment(new Date().getTime()).format('YYYY-MM');
                    // 选择月
                    this.currentMouth = moment(new Date().getTime()).format('YYYY-MM');
                    let currentDateMon = new Date();
                    // 获取当前月的第一天
                    this.startTime = this.getCurrentMonthFirst(currentDateMon) + ' ' + '00:00:00';
                    // 获取当前月的最后一天
                    this.endTime = this.getCurrentMonthLast(currentDateMon) + ' ' + '23:59:59';
                } else if (this.selectKey === 'all') {
                    this.startAllTime = '请选择开始时间';
                    this.endAllTime = '请选择结束时间';
                    this.startTime = '2018-01-01' + ' ' + '00:00:00'; ;
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD') + ' ' + '23:59:59';
                }
                this.dataList.map((item, index) => {
                    if (item.value === this.selectKey) {
                        this.$set(item, 'select', true)
                    } else {
                        this.$set(item, 'select', false);
                    }
                });
            },
            goLeaderDetail (item, value) {
                // 详情页面
                let start_date = this.startTime.replace(/\-/g, "/");
                let end_date = this.endTime.replace(/\-/g, "/");
                this.$router.push(
                    'statusList?areaOne=' +
                        item.area +
                        '&dafaultType=' +
                        this.dafaultType +
                        '&typeSign=' +
                        'complainState' +
                        '&selectKey=' +
                        this.selectKey +
                        '&startTime=' +
                        start_date +
                        '&endTime=' +
                        end_date +
                        '&clickNum=' + this.clickNum
                );
            },
            getInfoList (data) {
                this.proList = [];
                API.leader.getComplainStateDetail({
                    beginDate: this.startTime,
                    endDate: this.endTime,
                    areaOne: this.areaId
                }).then(res => {
                    if (res.ret === 0) {
                        this.baseList = res.data.complainStatistics.totalList;
                        this.totalPrice = res.data.complainStatistics.allList[0];
                        this.hour = this.totalPrice.completeAvgTime;
                        this.minutes = this.totalPrice.completeAvgTime;
                        if (this.baseList[data].value === '0') {
                            this.isNolist = true;
                        } else {
                            this.isNolist = false;
                        }
                        if (res.data.complainStatistics.cityList.length > 0) {
                            if (this.refundType === 'processing') {
                                let arr1 = res.data.complainStatistics.cityList.sort(function(a, b) {
                                  return b.notComplete - a.notComplete
                                })
                                this.list = arr1.filter(item => {
                                    return item.notComplete !== 0;
                                });
                            } else if (this.refundType === 'refundSuccess') {
                                let arr2 = res.data.complainStatistics.cityList.sort(function(a, b) {
                                  return b.normalComplete - a.normalComplete
                                })
                                this.list = arr2.filter(item => {
                                    return item.normalComplete !== 0;
                                });
                            } else if (this.refundType === 'waitAccept') {
                                let arr3 = res.data.complainStatistics.cityList.sort(function(a, b) {
                                    return b.timeoutComplete - a.timeoutComplete
                                  })
                                this.list = arr3.filter(item => {
                                    return item.timeoutComplete !== 0;
                                });
                            } else if (this.refundType === 'userRevoke') {
                              let arr4 = res.data.complainStatistics.cityList.sort(function(a, b) {
                                    return b.notaccept - a.notaccept
                                  })
                                this.list = arr4.filter(item => {
                                    return item.notaccept !== 0;
                                });
                            } else if (this.refundType === 'refuseAccept') {
                              let arr5 = res.data.complainStatistics.cityList.sort(function(a, b) {
                                    return b.revocation - a.revocation
                                  })
                                this.list = arr5.filter(item => {
                                    return item.revocation !== 0;
                                });
                            }
                            this.proList = this.list
                        }
                    }
                });
            },
            AllstartTime () {
                this.changeTime = 'startTime';
                this.$refs.timePick.showPicker();
            },
            AllendTime () {
                this.changeTime = 'endTime';
                this.$refs.timePick.showPicker();
            },
            getTimeValue (value) {
                if (this.changeTime === 'startTime') {
                    if (new Date(value).getTime() > new Date(this.endTime).getTime()) {
                        this.$Toast({
                            message: '开始时间不能大于当前时间'
                        });
                        return;
                    }
                    this.isopacity = false;
                    this.startAllTime = value;
                    this.startTime = value + ' 00:00:00';
                } else {
                    if (new Date(value).getTime() < new Date(this.startAllTime).getTime()) {
                        this.$Toast({
                            message: '结束时间不能小于开始时间'
                        });
                        return;
                    }
                    this.isopacity = false;
                    this.endAllTime = value;
                    this.endTime = value + ' 23:59:59';
                }
                if (this.startTime !== '' && this.endTime !== '') {
                    this.changeStatus(this.refundType, 0);
                }
            },
            selectALL (index, item) {
                this.$store.commit('complaint/setTodayType', item.value);
                // 选择日，周，月
                this.clickNum = 0;
                this.dataList.map((item, index) => {
                    this.$set(this.dataList[index], 'select', false);
                });
                this.$set(this.dataList[index], 'select', true);
                this.selectKey = item.value;
                if (item.value === 'today') {
                    this.currentTime = new Date().getTime();
                    // 选择日
                    this.aboutDay = moment(new Date().getTime()).format('YYYY-MM-DD');
                    this.startTime = moment(new Date().getTime()).format(
                        'YYYY-MM-DD' + ' ' + '00:00:00'
                    );
                    this.endTime = moment(new Date().getTime()).format(
                        'YYYY-MM-DD' + ' ' + '23:59:59'
                    );
                } else if (item.value === 'week') {
                    // 选择周
                    let nowTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    var data = util.getWeekStartEnd(moment, nowTime);
                    this.startWeekTime = data.start;
                    this.endWeekTime = data.end;
                    this.startTime = data.start + ' ' + '00:00:00';
                    this.endTime = data.end + ' ' + '23:59:59';
                } else if (item.value === 'month') {
                    this.currentMouth = moment(new Date().getTime()).format('YYYY-MM');
                    // 选择月
                    this.currentMouth = moment(new Date().getTime()).format('YYYY-MM');
                    let currentDateMon = new Date();
                    // 获取当前月的第一天
                    this.startTime = this.getCurrentMonthFirst(currentDateMon) + ' ' + '00:00:00';
                    // 获取当前月的最后一天
                    this.endTime = this.getCurrentMonthLast(currentDateMon) + ' ' + '23:59:59';
                } else if (item.value === 'all') {
                    //
                    this.startAllTime = '请选择开始时间';
                    this.endAllTime = '请选择结束时间';
                    this.startTime = '2018-01-01' + ' ' + '00:00:00'; ;
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD') + ' ' + '23:59:59'; ;
                }
                this.refundType = 'processing'
                this.changeStatus(this.refundType, 0);
            },
            getCurrentMonthFirst (d) {
                // 每个月第一天
                var date = new Date(d);
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getCurrentMonthLast (d) {
                // 每个月最后一天
                var date = new Date(d);
                var currentMonth = date.getMonth();
                var nextMonth = ++currentMonth;
                var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                var oneDay = 1000 * 60 * 60 * 24;
                var lastTime = new Date(nextMonthFirstDay - oneDay);
                var month = parseInt(lastTime.getMonth() + 1);
                var day = lastTime.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            preDate () {
                // 上一天
                this.clickNum++;
                this.aboutDay = moment(this.currentTime - 24 * 60 * 60 * 1000).format(
                    'YYYY-MM-DD'
                );
                this.currentTime = new Date(this.aboutDay).getTime();
                this.startTime = this.aboutDay + ' ' + '00:00:00';
                this.endTime = this.aboutDay + ' ' + '23:59:59';
                this.changeStatus(this.refundType, 0);
            },
            nextDate () {
                // 下一天
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                this.aboutDay = moment(this.currentTime + 24 * 60 * 60 * 1000).format(
                    'YYYY-MM-DD'
                );
                this.currentTime = new Date(this.aboutDay).getTime();
                this.startTime = this.aboutDay + ' ' + '00:00:00';
                this.endTime = this.aboutDay + ' ' + '23:59:59';
                this.changeStatus(this.refundType, 0);
            },
            preMouth () {
                // 上一个月
                this.clickNum++;
                if (new Date(this.currentMouth).getMonth() > 0) {
                    var month = parseInt(new Date(this.currentMouth).getMonth());
                    if (month < 10) {
                        month = '0' + month;
                    }
                    this.currentMouth =
                        new Date(this.currentMouth).getFullYear() + '-' + month + '';
                } else {
                    this.currentMouth =
                        parseInt(new Date(this.currentMouth).getFullYear()) - 1 + '-' + '12';
                }
                var time = new Date(
                    this.currentMouth.substring(0, 4),
                    this.currentMouth.substring(5, 7),
                    0
                );
                this.startTime = this.currentMouth + '-01' + ' ' + '00:00:00';
                this.endTime = this.currentMouth + '-' + time.getDate() + ' ' + '23:59:59';
                this.changeStatus(this.refundType, 0);
            },
            nextMouth () {
                // 下一个月
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                var month = parseInt(new Date(this.currentMouth).getMonth()) + 2;
                if (month < 10) {
                    month = '0' + month;
                }
                if (month > 12) {
                    this.currentMouth =
                        parseInt(new Date(this.currentMouth).getFullYear()) + 1 + '-' + '01';
                } else {
                    this.currentMouth = new Date(this.currentMouth).getFullYear() + '-' + month;
                }
                var time = new Date(
                    this.currentMouth.substring(0, 4),
                    this.currentMouth.substring(5, 7),
                    0
                );
                this.startTime = this.currentMouth + '-01' + ' ' + '00:00:00';
                this.endTime = this.currentMouth + '-' + time.getDate() + ' ' + '23:59:59';
                this.changeStatus(this.refundType, 0);
            },
            preWeek () {
                // 上一周
                this.clickNum++;
                this.endWeekTime = moment(
                    new Date(this.startWeekTime).getTime() - 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startWeekTime = moment(
                    new Date(this.startWeekTime).getTime() - 7 * 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startTime = this.startWeekTime + ' ' + '00:00:00';
                this.endTime = this.endWeekTime + ' ' + '23:59:59';
                this.changeStatus(this.refundType, 0);
            },
            nextWeek () {
                // 下一周
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                this.startWeekTime = moment(
                    new Date(this.endWeekTime).getTime() + 24 * 36e5
                ).format('YYYY-MM-DD');
                this.endWeekTime = moment(
                    new Date(this.endWeekTime).getTime() + 7 * 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startTime = this.startWeekTime + ' ' + '00:00:00';
                this.endTime = this.endWeekTime + ' ' + '23:59:59';
                this.changeStatus(this.refundType, 0);
            },
            changeStatus (value, index) {
                this.getInfoList(index);
                this.refundType = value;
                switch (value) {
                case 'processing':
                    this.dafaultType = 'notComplete'
                    break;
                case 'refundSuccess':
                    this.dafaultType = 'normalComplete'
                    break;
                case 'waitAccept':
                    this.dafaultType = 'timeoutComplete'
                    break;
                case 'userRevoke':
                    this.dafaultType = 'notaccept'
                    break;
                case 'refuseAccept':
                    this.dafaultType = 'revocation'
                    break;
                }
                let btnList = ['processing', 'refundSuccess', 'waitAccept', 'userRevoke', 'refuseAccept']
                for (var i = 0; i < btnList.length; i++) {
                    this[btnList[i]] = false
                    if (btnList[i] === value) {
                        this[btnList[i]] = true
                    }
                }
            }
        },
        filters: {
            filt (value) {
                if (parseInt(value) < 10000) {
                    return value;
                } else if (parseInt(value) >= 10000 && parseInt(value) < 100000000) {
                    return (parseInt(value) / 10000).toFixed(2);
                } else if (parseInt(value) >= 100000000) {
                    return (parseInt(value) / 100000000).toFixed(2);
                }
            },
            filt1 (str) {
                let duration = str;

                let zero = function (times) {
                    return times;
                };
                let hour = zero(Math.floor(duration / 3600));
                let times = '';
                if (hour > 0) {
                    times += hour;
                } else {
                    times = hour;
                }
                return times;
            },
            filt2 (str) {
                let duration = str;
                let zero = function (times) {
                    return times;
                };
                let minutes = zero(Math.ceil((duration / 60) % 60));
                let times = '';
                times += minutes;
                return times;
            }
        }
    };
</script>
<style scoped lang="less">
.b_box {
  background-color: #fafafa;
  min-height: 62%;
}
.container {
  //   width: 100%;
  min-height: 100%;
  .top_title {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: #36b374;
    .s_time {
      height: 30px;
      padding: 20px 16px 0 16px;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-around;
      font-size: 16px;
      color: #666;
      background-color: #36b374;
      border: 1px solid #ffffff;
      border-radius: 2px;
      .item {
        display: block;
        float: left;
        width: 25%;
        height: 100%;
        line-height: 30px;
        text-align: center;
        color: #ccc;
        border-right: 1px solid #ffffff;
      }
      .item:last-child {
        border: none;
      }
      .select_active {
        color: #36b374;
        background-color: #fff;
      }
    }
    .t_data {
      width: 100%;
      height: 200px;
      background: #36b374;
      padding: 20px 16px 0 16px;
      box-sizing: border-box;
      position: relative;
      .jiao {
        position: absolute;
        left: 29px;
        top: -21px;
        width: 14px;
        height: 14px;
        border-top: 14px solid transparent;
        border-right: 14px solid transparent;
        border-bottom: 14px solid #36b374;
        border-left: 14px solid transparent;
      }
      .jiao1_active {
        left: 29px;
      }
      .jiao2_active {
        left: 120px;
      }
      .jiao3_active {
        left: 210px;
      }
      .jiao4_active {
        left: 307px;
      }
      .s_data {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        .s_left {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          flex-direction: row;
          img {
            width: 7px;
            height: 11px;
          }
          span {
            font-size: 14px;
            color: #fff;
            margin-left: 6px;
          }
          .s_active {
            opacity: 0.3 !important;
          }
          .s_img {
            opacity: 0.3 !important;
          }
        }
        .all_center {
          font-size: 14px;
          color: #fff;
          opacity: 0.4;
        }
        .all_left {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          flex-direction: row;
          span {
            font-size: 14px;
            color: #fff;
          }
          img {
            width: 11px;
            height: 7px;
            margin-left: 6px;
          }
          .s_active {
            opacity: 0.3 !important;
          }
        }
        // .all_active {
        //   opacity: 0.5;
        // }
        .s_right {
          img {
            margin-left: 6px;
          }
        }
        .nextactive {
          color: #ccc;
        }
        .center {
          color: #fff;
          font-size: 14px;
        }
        .center_active {
          opacity: 0.5 !important;
        }
      }
      .two_data {
        justify-content: space-around;
      }
      .pro_item {
        width: 100%;
        margin-top: 16px;
        position: relative;
        .item_left {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          flex-direction: row;
          justify-content: space-around;
          .left {
            display: inline-block;
            text-align: center;
            width: 50%;
            .num {
              margin-top:22px;
              span:nth-child(1) {
                font-size: 36px;
                color: #fff;
                display: inline-block;
                font-family:PingFangSC-Regular,PingFang SC;
                -webkit-font-smoothing: antialiased;
                font-weight: 700;
              }
              span:nth-child(2) {
                font-size: 10px;
                color: #fff;
                display: inline-block;
                margin-left: 1px;
              }
              span:nth-child(3) {
                font-size: 36px;
                color: #fff;
                display: inline-block;
                margin-left: 4px;
                font-family:PingFangSC-Regular,PingFang SC;
                -webkit-font-smoothing: antialiased;
                font-weight: 700;
                margin-left: 8px;
              }
              span:nth-child(4) {
                font-size: 10px;
                color: #fff;
                display: inline-block;
                margin-left: 1px;
              }
            }
            .status {
              font-size: 14px;
              margin-top: 16px;
              color: #fff;
            }
          }
          .center {
            width: 1px;
            height: 40px;
            background: #ccc;
            opacity: 0.6;
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            -webkit-transform: scaleX(0.5);
            transform: scaleX(0.5);
          }
        }
      }
      .status_num {
        width: 100%;
        height: 82px;
        padding: 0 12px;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        bottom: -41px;
        .status_item {
          width: 100%;
          height: 100%;
          background-color: #fff;
          border-radius: 4px;
          //    box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
          //    box-shadow: 2px 1px 2px rgba(0, 0, 0, 0.04);
          box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
          display: flex;
          display: -webkit-flex;
          align-items: center;
          flex-direction: row;
          justify-content: space-around;
          padding: 0 12px;
          .item_num {
            text-align: center;
            .pro_status {
              font-size: 12px;
              color: #999999;
            }
            .pro_actve {
              color: #36b374 !important;
            }
            .pro_num {
              margin-top: 10px;
              span:nth-child(1) {
                font-size: 18px;
                color: #999999;
                font-family:PingFangSC-Regular,PingFang SC;
                -webkit-font-smoothing: antialiased;
                font-weight: 700;
              }
              span:nth-child(2) {
                font-size: 12px;
                color: #999999;
              }
            }
          }
          .line {
            width: 1px;
            height: 20px;
            background-color: #efefef;
          }
        }
      }
    }
  }
  .box_nav {
    width: 100%;
    text-align: center;
    font-size: 0;
    padding-top: 20px;
    .box_item:nth-child(1) {
      border-left: 1px solid rgba(255, 255, 255, 0.5);
      // border-left:1px solid #fff;
    }
    .box_item {
      display: inline-block;
      width: 78px;
      height: 30px;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      // border-right: 1px solid #fff;
      // border-bottom: 1px solid #fff;
      // border-top: 1px solid #fff;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      color: #fff;
      opacity: 0.7;
    }
    .select_active1 {
      background-color: #fff;
      color: @base-color;
      opacity: 1;
    }
    .boxLeft {
      border-radius: 2px 0 0 2px;
    }
    .boxRigtht {
      border-radius: 0 2px 2px 0;
    }
  }
  .all_list {
    box-sizing: border-box;
    padding: 12px;
    overflow: hidden;
    margin-top: 250px;
    background-color: #fafafa;
    .all_list_top {
      margin-top: 50px;
      overflow: hidden;
      background-color: #ffffff;
      padding-left: 18px;
      padding-right: 18px;
      margin-bottom: 20px;
      box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
    }
    .all_list_item {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      line-height: 32px;
      span {
        font-size: 14px;
        color: #4a4a4a;
      }
    }
    .all_list_active {
      border-bottom: 1px solid #efefef;
    }
    .all_item {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      padding: 24px 0;
      font-size: 0;
      .tip_one {
        font-size: 13px;
        width: 40%;
        line-height: 16px;
        color: #4a4a4a;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tip_two {
        width: 20%;
        font-size: 14px;
        color: #4a4a4a;
        text-align: left;
      }
      .right {
        width: 40%;
        float: right;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: right;
        .price {
          font-size: 14px;
          color: #4a4a4a;
          display: inline-block;
          margin-right: 10px;
          // color:red;
        }
        .arrow_right {
          width: 5px;
          height: 8px;
          margin-left: 6px;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      height: 268px;
      img {
        display: inline-block;
        width: 72px;
        height: 64px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
    .all_list_null {
      background-color: #fafafa;
      width: 100%;
      height: 330px;
    }
  }
  .animate_active {
    animation: changehide 1s ease-out forwards;
  }
  .animate_active1 {
    animation: changehide1 1s ease-out backwards;
  }
  @keyframes changehide {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
}
</style>
